
/**
 * LayoutStylesProcessor - Creates styles for layout utilities
 */
export class LayoutStylesProcessor {
  static createLayoutStyles(): string {
    return `
      .onexip-calculator-wrapper {
        max-width: 100% !important;
        background-color: white !important;
        border-radius: 0.5rem !important;
        overflow: hidden !important;
        padding: 1rem !important;
      }
      
      /* Step indicator layout */
      .onexip-calculator-container .step-item {
        display: flex !important;
        flex-direction: column !important;
        align-items: center !important;
        justify-content: center !important;
        position: relative !important;
        z-index: 1 !important;
        flex: 1 !important;
      }
      
      /* Platform selector grid */
      .onexip-calculator-container .grid {
        display: grid !important;
      }
      
      .onexip-calculator-container .grid-cols-1 {
        grid-template-columns: repeat(1, minmax(0, 1fr)) !important;
      }
      
      @media (min-width: 768px) {
        .onexip-calculator-container .md\\:grid-cols-2 {
          grid-template-columns: repeat(2, minmax(0, 1fr)) !important;
        }
      }
    `;
  }
}
